import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d145456c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theo-doi-hop-dong-thead" }
const _hoisted_2 = { class: "theo-doi-hop-dong-header-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center theo-doi-hop-dong-th-meta break-word"
}, " TT ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center theo-doi-hop-dong-th-meta break-word"
}, " Mã VT ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center theo-doi-hop-dong-th-meta break-word"
}, " Tên vật tư ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center theo-doi-hop-dong-th-meta break-word"
}, " Đặc tính ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center theo-doi-hop-dong-th-meta break-word"
}, " Đ/vị tính ", -1))
const _hoisted_8 = { class: "theo-doi-hop-dong-header-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Số lượng", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Đơn giá", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Thành tiền", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "theo-doi-hop-dong-header-row" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic theo-doi-hop-dong-th-meta" }, "A"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic theo-doi-hop-dong-th-meta" }, "B"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic theo-doi-hop-dong-th-meta" }, "C"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic theo-doi-hop-dong-th-meta" }, "D"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic theo-doi-hop-dong-th-meta" }, "E"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "3 = 1 * 2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "4"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "5"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "6 = 4 * 5"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "7 = 1 - 4"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "8 = 2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "9 = 7 * 8")
], -1))
const _hoisted_13 = { class: "theo-doi-hop-dong-tbody" }
const _hoisted_14 = { class: "text-center break-word" }
const _hoisted_15 = { class: "break-word" }
const _hoisted_16 = { class: "break-word" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "break-word" }, null, -1))
const _hoisted_18 = { class: "break-word" }
const _hoisted_19 = { class: "text-end break-word" }
const _hoisted_20 = { class: "text-end break-word" }
const _hoisted_21 = { class: "text-end fw-bolder break-word" }
const _hoisted_22 = { class: "text-end break-word" }
const _hoisted_23 = { class: "text-end break-word" }
const _hoisted_24 = { class: "text-end fw-bolder break-word" }
const _hoisted_25 = { class: "text-end break-word" }
const _hoisted_26 = { class: "text-end break-word" }
const _hoisted_27 = { class: "text-end fw-bolder break-word" }
const _hoisted_28 = { class: "bao-cao-table-total-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "5"
}, "Cộng", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_32 = { class: "text-end fw-bolder" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_35 = { class: "text-end fw-bolder" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_38 = { class: "text-end fw-bolder" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "14",
  class: "text-center"
}, "Không có dữ liệu", -1))
const _hoisted_41 = [
  _hoisted_40
]

import { computed, PropType } from "vue";
import { REPORT_COLUMN_WIDTHS } from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";
import { ITheoDoiThucHienHopDongResponseBase } from "@/core/interfaces/ApiResponses";
import {
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiHopDongTable',
  props: {
  isPrintModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<ITheoDoiThucHienHopDongResponseBase[]>,
    required: true,
  },
  stripe: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
},
  setup(__props) {

const COLUMN_WEIGHT_TOTAL =
  REPORT_COLUMN_WIDTHS.stt +
  REPORT_COLUMN_WIDTHS.ma +
  REPORT_COLUMN_WIDTHS.ten +
  REPORT_COLUMN_WIDTHS.dacTinh +
  REPORT_COLUMN_WIDTHS.dvt +
  (REPORT_COLUMN_WIDTHS.soLuong +
    REPORT_COLUMN_WIDTHS.donGia +
    REPORT_COLUMN_WIDTHS.thanhTien) *
    3;

const toColPercent = (weight: number) =>
  `${((weight / COLUMN_WEIGHT_TOTAL) * 100).toFixed(3)}%`;

const colW = {
  stt: toColPercent(REPORT_COLUMN_WIDTHS.stt),
  ma: toColPercent(REPORT_COLUMN_WIDTHS.ma),
  ten: toColPercent(REPORT_COLUMN_WIDTHS.ten),
  dacTinh: toColPercent(REPORT_COLUMN_WIDTHS.dacTinh),
  dvt: toColPercent(REPORT_COLUMN_WIDTHS.dvt),
  soLuong: toColPercent(REPORT_COLUMN_WIDTHS.soLuong),
  donGia: toColPercent(REPORT_COLUMN_WIDTHS.donGia),
  thanhTien: toColPercent(REPORT_COLUMN_WIDTHS.thanhTien),
};

const headers = ["Theo Hợp đồng", "Thực hiện", "Chênh lệch"];

const props = __props;

const totalThanhTien = computed(() => {
  let result = {
    hop_dong: 0,
    thuc_hien: 0,
    chenh_lech: 0,
  };

  props.items?.forEach(
    ({ thanh_tien_hop_dong, thanh_tien_nhap_kho, thanh_tien_chenh_lech }) => {
      result.hop_dong += +thanh_tien_hop_dong || 0;
      result.thuc_hien += +thanh_tien_nhap_kho || 0;
      result.chenh_lech += +thanh_tien_chenh_lech || 0;
    }
  );

  return {
    hop_dong: formatAmount(Math.round(result.hop_dong)),
    thuc_hien: formatAmount(Math.round(result.thuc_hien)),
    chenh_lech: formatAmount(Math.round(result.chenh_lech)),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    style: { width: '100%', fontSize: '0.8rem' },
    class: _normalizeClass({
      'table-striped': __props.stripe,
      'bao-cao-table--print': __props.isPrintModal,
    })
  }, [
    _createElementVNode("colgroup", null, [
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.stt })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.ma })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.ten })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.dacTinh })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.dvt })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4)
    ]),
    _createElementVNode("thead", _hoisted_1, [
      _createElementVNode("tr", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header, index) => {
          return _createElementVNode("th", {
            key: index,
            class: "text-center break-word",
            colspan: "3"
          }, _toDisplayString(header), 1)
        }), 64))
      ]),
      _createElementVNode("tr", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.length, (n) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ], 64))
        }), 128))
      ]),
      _hoisted_12
    ]),
    _createElementVNode("tbody", _hoisted_13, [
      (__props.items.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.ma_vat_tu,
                class: _normalizeClass({
            'bao-cao-table-data-row': __props.isPrintModal,
            'bao-cao-table-data-row--last':
              __props.isPrintModal && index === __props.items.length - 1,
          })
              }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(item.ma_vat_tu), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(item.ten_vat_tu), 1),
                _hoisted_17,
                _createElementVNode("td", _hoisted_18, _toDisplayString(item.don_vi_tinh), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatQuantity)(item.so_luong_hop_dong)), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatUnitPrice)(item.don_gia_hop_dong)), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatAmount)(item.thanh_tien_hop_dong)), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatQuantity)(item.so_luong_nhap_kho)), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatUnitPrice)(item.don_gia_nhap_kho)), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(formatAmount)(item.thanh_tien_nhap_kho)), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatQuantity)(item.so_luong_chenh_lech)), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(formatUnitPrice)(item.don_gia_hop_dong)), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatAmount)(item.thanh_tien_chenh_lech)), 1)
              ], 2))
            }), 128)),
            _createElementVNode("tr", _hoisted_28, [
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("td", _hoisted_32, _toDisplayString(totalThanhTien.value.hop_dong), 1),
              _hoisted_33,
              _hoisted_34,
              _createElementVNode("td", _hoisted_35, _toDisplayString(totalThanhTien.value.thuc_hien), 1),
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("td", _hoisted_38, _toDisplayString(totalThanhTien.value.chenh_lech), 1)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("tr", _hoisted_39, _hoisted_41))
    ])
  ], 2))
}
}

})